var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

/** @module utils/ref */

/**
 * A utility function to set/save `ref`.
 *
 * @param {function|object} target - a function or an object that is used to save given reference
 * @param {object} value - a reference value that should be saved
 */
export default function setRef(target, value) {
  if (target) {
    var targetType = typeof target === 'undefined' ? 'undefined' : _typeof(target);
    if (targetType === 'function') {
      target(value);
    } else if (targetType === 'object') {
      target.current = value;
    }
  }
}